import { encodeBaseUrl } from '..';

export const setUrlWithCustomSubpage = (link: string, subpage: string) => {
  const url = link.replaceAll(',-w-,', '');
  return encodeBaseUrl(`${url}${subpage}`);
};
